import type { ReactNode } from 'react';
import styles from './ListItem.module.css';

interface ListItemProps {
  title: string;
  IconComponent?: ReactNode;
  onPress?: () => void;
}

export function ListItem({ title, IconComponent, onPress }: ListItemProps) {
  return (
    <div className={styles.container} onClick={onPress}>
      {IconComponent && <div className={styles.icon}>{IconComponent}</div>}
      <span className={styles.title}>{title}</span>
      <span className={styles.chevron}>›</span>
    </div>
  );
}

export default ListItem;
